import React, { PropsWithChildren } from "react";
import styles from "./AmpWarning.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning } from "@fortawesome/free-solid-svg-icons";

export interface AmpWarningProps extends PropsWithChildren {
    show: boolean
}

export default function AmpWarning(props: AmpWarningProps) {
    return (
        <div className={`${styles.Warning} ${props.show && styles.Show}`}>
            <FontAwesomeIcon icon={faWarning} size="2x"/>
            {props.children}
        </div>

    )
}